
import ScoringStats from '../../components/ScoringStats';

function ScoringPage() {

  return (
      <ScoringStats/>
  )
}
export default ScoringPage